import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "../components/LegalLayout";
import { EMPRESA } from "../legal/empresa";

const TITULOS = { pt: "Termos de Uso", en: "Terms of Use", es: "Términos de Uso" };
const ATUALIZADO = { pt: "18 de agosto de 2026", en: "August 18, 2026", es: "18 de agosto de 2026" };

export default function TermosDeUso() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || "pt").slice(0, 2);

  const CONTEUDO = {
    pt: (
      <>
        <p>
          Estes Termos de Uso regulam a contratação e utilização do {EMPRESA.nomeFantasia},
          sistema de gestão em nuvem oferecido por {EMPRESA.razaoSocial} (CNPJ {EMPRESA.cnpj}),
          com sede em {EMPRESA.cidade}/{EMPRESA.uf}. Ao criar uma conta ou usar o painel, você
          concorda com estes termos e com nossa <a href="/privacidade">Política de Privacidade</a>.
          A relação de consumo aqui estabelecida é regida pelo Código de Defesa do Consumidor
          (Lei nº 8.078/1990) e pelo Marco Civil da Internet (Lei nº 12.965/2014).
        </p>

        <h2>1. O que é o serviço</h2>
        <p>O {EMPRESA.nomeFantasia} é um sistema de gestão (SaaS) para pequenos e médios
          negócios, com módulos de ordens de serviço, orçamentos, cadastro de clientes,
          controle de estoque, financeiro e agendamentos, acessado pela internet mediante
          login e senha.</p>

        <h2>2. Cadastro e conta de acesso</h2>
        <p>Você é responsável por fornecer informações verdadeiras no cadastro e por manter
          sua senha em sigilo. Todo acesso feito com suas credenciais é considerado feito por
          você. Avise-nos imediatamente em caso de uso não autorizado da sua conta.</p>

        <h2>3. Planos e pagamento</h2>
        <p>O {EMPRESA.nomeFantasia} é oferecido em dois planos — <strong>Básico</strong> e
          {" "}<strong>Premium</strong> —, cada um com sua própria mensalidade e, quando
          aplicável, taxa de implantação. Os valores e limites
          vigentes de cada plano são sempre exibidos na tela de contratação/assinatura antes
          da confirmação do pagamento, e podem ser reajustados a qualquer momento, valendo o
          valor vigente no momento da nova cobrança. O plano Básico pode incluir um período
          de teste gratuito, informado na própria tela de contratação. A cobrança dos planos
          pagos é recorrente (mensal) e processada pelo Mercado Pago (cartão de crédito ou
          Pix); não armazenamos os dados completos do seu cartão. O acesso ao plano contratado
          é liberado automaticamente após a confirmação do pagamento.</p>

        <h2>4. Direito de arrependimento</h2>
        <p>Em contratações feitas fora do estabelecimento comercial (à distância, pela
          internet), você tem o direito de desistir do contrato em até <strong>7 (sete) dias
          corridos</strong> a contar da assinatura do primeiro plano pago, nos termos do art.
          49 do Código de Defesa do Consumidor, com reembolso integral do valor pago nesse
          período. Basta solicitar pelo nosso contato.</p>

        <h2>5. Cancelamento</h2>
        <p>Você pode cancelar sua assinatura a qualquer momento, sem multa, diretamente pelo
          painel ou solicitando por e-mail. O cancelamento interrompe as cobranças futuras;
          o acesso ao plano pago permanece até o fim do ciclo já pago, sem reembolso
          proporcional do período restante, exceto no caso do direito de arrependimento
          descrito no item 4.</p>

        <h2>6. Seus dados e seu conteúdo</h2>
        <p>Todo conteúdo que você insere no sistema (clientes, ordens de serviço, orçamentos,
          estoque, financeiro) pertence a você e ao seu negócio. Usamos esses dados apenas
          para prestar o serviço contratado, conforme nossa <a href="/privacidade">Política de
          Privacidade</a>. Em caso de cancelamento, você pode solicitar a exportação dos seus
          dados dentro do prazo informado no momento do cancelamento.</p>

        <h2>7. Uso adequado da plataforma</h2>
        <p>Não é permitido: (a) usar o sistema para fins ilícitos; (b) tentar acessar dados
          de outros clientes (isolamento entre contas/tenants) ou comprometer a segurança da
          plataforma; (c) fazer engenharia reversa do software; (d) revender ou sublicenciar
          o acesso sem autorização.</p>

        <h2>8. Propriedade intelectual</h2>
        <p>O software, marca, layout e demais elementos do {EMPRESA.nomeFantasia} são de
          propriedade de {EMPRESA.razaoSocial} ou licenciados a ela, não sendo permitida
          cópia, distribuição ou uso fora do escopo desta contratação.</p>

        <h2>9. Disponibilidade e suporte</h2>
        <p>Trabalhamos para manter o serviço disponível continuamente, mas não garantimos
          disponibilidade ininterrupta (100% uptime), podendo haver interrupções para
          manutenção ou por fatores fora do nosso controle. O suporte é prestado pelos canais
          informados no painel, com prazo de resposta variável conforme o plano contratado
          (Básico: até 48h úteis por e-mail; Premium: até 4h úteis, WhatsApp e e-mail).</p>

        <h2>10. Limitação de responsabilidade</h2>
        <p>O {EMPRESA.nomeFantasia} é uma ferramenta de apoio à gestão do seu negócio e não
          substitui obrigações contábeis, fiscais ou jurídicas próprias da sua empresa. Não
          nos responsabilizamos por decisões tomadas exclusivamente com base nos relatórios
          do sistema, nem por danos indiretos decorrentes de uso indevido da plataforma.</p>

        <h2>11. Suspensão e rescisão</h2>
        <p>Podemos suspender ou encerrar o acesso em caso de descumprimento destes termos,
          inadimplência não sanada após aviso, ou uso fraudulento/ilícito da plataforma.</p>

        <h2>12. Alterações destes termos</h2>
        <p>Podemos atualizar estes Termos de Uso para refletir mudanças legais, operacionais
          ou nos planos oferecidos. A data no topo desta página indica a versão vigente.
          Alterações relevantes serão comunicadas pelos canais de contato cadastrados.</p>

        <h2>13. Legislação aplicável e foro</h2>
        <p>Estes termos são regidos pelas leis da República Federativa do Brasil. Fica eleito
          o foro da comarca de {EMPRESA.cidade}/{EMPRESA.uf} para dirimir eventuais
          controvérsias, ressalvado o foro do domicílio do consumidor quando a lei assim
          determinar.</p>

        <h2>14. Contato</h2>
        <p><a href={`mailto:${EMPRESA.contatoEmail}`}>{EMPRESA.contatoEmail}</a></p>
      </>
    ),
    en: (
      <>
        <p>
          These Terms of Use govern the contracting and use of {EMPRESA.nomeFantasia}, a
          cloud management system offered by {EMPRESA.razaoSocial} (Brazilian company
          registration/CNPJ {EMPRESA.cnpj}), headquartered in {EMPRESA.cidade}, {EMPRESA.uf},
          Brazil. By creating an account or using the panel, you agree to these terms and to
          our <a href="/privacidade">Privacy Policy</a>. This consumer relationship is
          governed by Brazil's Consumer Protection Code (Law No. 8,078/1990) and the
          Brazilian Internet Civil Framework (Law No. 12,965/2014).
        </p>

        <h2>1. What the service is</h2>
        <p>{EMPRESA.nomeFantasia} is a management system (SaaS) for small and medium
          businesses, with modules for service orders, quotes, customer records, inventory
          control, finance, and scheduling, accessed online via login and password.</p>

        <h2>2. Registration and access account</h2>
        <p>You are responsible for providing truthful information at registration and for
          keeping your password confidential. Any access made with your credentials is
          considered made by you. Notify us immediately in case of unauthorized use of your
          account.</p>

        <h2>3. Plans and payment</h2>
        <p>{EMPRESA.nomeFantasia} is offered in two plans — <strong>Basic</strong> and{" "}
          <strong>Premium</strong> — each with its own monthly fee and, where applicable, a
          setup fee. Current pricing and limits for each plan are always shown on the
          checkout/subscription screen before payment is confirmed, and may be adjusted at
          any time, with the price in effect at the time of the next billing cycle applying.
          The Basic plan may include a free trial period, indicated on the checkout screen
          itself. Paid plans are billed on a recurring (monthly) basis and processed by
          Mercado Pago (credit card or Pix); we do not store your full card details. Access
          to the contracted plan is released automatically after payment confirmation.</p>

        <h2>4. Right of withdrawal</h2>
        <p>For contracts entered into away from a commercial establishment (remotely, over
          the internet), you have the right to withdraw from the contract within{" "}
          <strong>7 (seven) calendar days</strong> of subscribing to your first paid plan,
          under art. 49 of Brazil's Consumer Protection Code, with a full refund of the
          amount paid during that period. Simply request it through our contact channel.</p>

        <h2>5. Cancellation</h2>
        <p>You may cancel your subscription at any time, without penalty, directly through
          the panel or by emailing us. Cancellation stops future charges; access to the paid
          plan remains active until the end of the already-paid billing cycle, with no
          pro-rated refund for the remaining period, except in the case of the right of
          withdrawal described in item 4.</p>

        <h2>6. Your data and your content</h2>
        <p>All content you enter into the system (customers, service orders, quotes,
          inventory, finance) belongs to you and your business. We use this data only to
          provide the contracted service, as described in our{" "}
          <a href="/privacidade">Privacy Policy</a>. Upon cancellation, you may request an
          export of your data within the period stated at the time of cancellation.</p>

        <h2>7. Acceptable use of the platform</h2>
        <p>You may not: (a) use the system for unlawful purposes; (b) attempt to access
          other customers' data (account/tenant isolation) or compromise the platform's
          security; (c) reverse-engineer the software; (d) resell or sublicense access
          without authorization.</p>

        <h2>8. Intellectual property</h2>
        <p>The software, brand, layout, and other elements of {EMPRESA.nomeFantasia} are
          owned by, or licensed to, {EMPRESA.razaoSocial}, and may not be copied,
          distributed, or used outside the scope of this agreement.</p>

        <h2>9. Availability and support</h2>
        <p>We work to keep the service continuously available, but we do not guarantee
          uninterrupted (100%) uptime, and there may be interruptions for maintenance or
          factors beyond our control. Support is provided through the channels listed in
          the panel, with response times varying by plan (Basic: within 48 business hours
          by email; Premium: within 4 business hours, via WhatsApp and email).</p>

        <h2>10. Limitation of liability</h2>
        <p>{EMPRESA.nomeFantasia} is a tool to support the management of your business and
          does not replace your company's own accounting, tax, or legal obligations. We are
          not liable for decisions made solely based on the system's reports, nor for
          indirect damages resulting from misuse of the platform.</p>

        <h2>11. Suspension and termination</h2>
        <p>We may suspend or terminate access in case of breach of these terms, unresolved
          non-payment after notice, or fraudulent/unlawful use of the platform.</p>

        <h2>12. Changes to these terms</h2>
        <p>We may update these Terms of Use to reflect legal, operational, or plan changes.
          The date at the top of this page indicates the current version. Material changes
          will be communicated through your registered contact channels.</p>

        <h2>13. Governing law and jurisdiction</h2>
        <p>These terms are governed by the laws of the Federative Republic of Brazil. The
          courts of {EMPRESA.cidade}, {EMPRESA.uf}, Brazil are elected to resolve any
          disputes, without prejudice to the consumer's domicile jurisdiction where required
          by law.</p>

        <h2>14. Contact</h2>
        <p><a href={`mailto:${EMPRESA.contatoEmail}`}>{EMPRESA.contatoEmail}</a></p>
      </>
    ),
    es: (
      <>
        <p>
          Estos Términos de Uso regulan la contratación y el uso de {EMPRESA.nomeFantasia},
          sistema de gestión en la nube ofrecido por {EMPRESA.razaoSocial} (CNPJ {EMPRESA.cnpj}),
          con sede en {EMPRESA.cidade}, {EMPRESA.uf}, Brasil. Al crear una cuenta o usar el
          panel, usted acepta estos términos y nuestra{" "}
          <a href="/privacidade">Política de Privacidad</a>. Esta relación de consumo se
          rige por el Código de Defensa del Consumidor de Brasil (Ley n.º 8.078/1990) y por
          el Marco Civil de Internet (Ley n.º 12.965/2014).
        </p>

        <h2>1. Qué es el servicio</h2>
        <p>{EMPRESA.nomeFantasia} es un sistema de gestión (SaaS) para pequeñas y medianas
          empresas, con módulos de órdenes de servicio, presupuestos, registro de clientes,
          control de inventario, finanzas y agendamientos, accesible por internet mediante
          usuario y contraseña.</p>

        <h2>2. Registro y cuenta de acceso</h2>
        <p>Usted es responsable de proporcionar información veraz en el registro y de
          mantener su contraseña en secreto. Todo acceso realizado con sus credenciales se
          considera realizado por usted. Avísenos de inmediato en caso de uso no autorizado
          de su cuenta.</p>

        <h2>3. Planes y pago</h2>
        <p>{EMPRESA.nomeFantasia} se ofrece en dos planes — <strong>Básico</strong> y{" "}
          <strong>Premium</strong> —, cada uno con su propia mensualidad y, cuando
          corresponda, una tarifa de implementación. Los valores y límites vigentes de cada
          plan siempre se muestran en la pantalla de contratación/suscripción antes de
          confirmar el pago, y pueden ajustarse en cualquier momento, aplicándose el valor
          vigente en el momento del siguiente cobro. El plan Básico puede incluir un período
          de prueba gratuito, indicado en la propia pantalla de contratación. El cobro de
          los planes pagos es recurrente (mensual) y se procesa a través de Mercado Pago
          (tarjeta de crédito o Pix); no almacenamos los datos completos de su tarjeta. El
          acceso al plan contratado se habilita automáticamente tras la confirmación del
          pago.</p>

        <h2>4. Derecho de desistimiento</h2>
        <p>En contrataciones realizadas fuera del establecimiento comercial (a distancia,
          por internet), usted tiene derecho a desistir del contrato dentro de los{" "}
          <strong>7 (siete) días corridos</strong> a partir de la suscripción de su primer
          plan pago, conforme al art. 49 del Código de Defensa del Consumidor de Brasil, con
          reembolso íntegro del valor pagado en ese período. Basta con solicitarlo a través
          de nuestro contacto.</p>

        <h2>5. Cancelación</h2>
        <p>Usted puede cancelar su suscripción en cualquier momento, sin penalización,
          directamente desde el panel o solicitándolo por correo electrónico. La cancelación
          detiene los cobros futuros; el acceso al plan pago permanece hasta el final del
          ciclo ya pagado, sin reembolso proporcional del período restante, salvo en el caso
          del derecho de desistimiento descrito en el punto 4.</p>

        <h2>6. Sus datos y su contenido</h2>
        <p>Todo el contenido que usted ingresa en el sistema (clientes, órdenes de servicio,
          presupuestos, inventario, finanzas) le pertenece a usted y a su negocio. Usamos
          esos datos únicamente para prestar el servicio contratado, conforme a nuestra{" "}
          <a href="/privacidade">Política de Privacidad</a>. En caso de cancelación, puede
          solicitar la exportación de sus datos dentro del plazo informado en el momento de
          la cancelación.</p>

        <h2>7. Uso adecuado de la plataforma</h2>
        <p>No está permitido: (a) usar el sistema con fines ilícitos; (b) intentar acceder a
          datos de otros clientes (aislamiento entre cuentas/tenants) o comprometer la
          seguridad de la plataforma; (c) realizar ingeniería inversa del software; (d)
          revender o sublicenciar el acceso sin autorización.</p>

        <h2>8. Propiedad intelectual</h2>
        <p>El software, la marca, el diseño y demás elementos de {EMPRESA.nomeFantasia} son
          propiedad de {EMPRESA.razaoSocial} o están licenciados a ella, no estando
          permitida su copia, distribución o uso fuera del alcance de esta contratación.</p>

        <h2>9. Disponibilidad y soporte</h2>
        <p>Trabajamos para mantener el servicio disponible de forma continua, pero no
          garantizamos disponibilidad ininterrumpida (100% uptime), pudiendo haber
          interrupciones por mantenimiento o factores fuera de nuestro control. El soporte
          se presta por los canales informados en el panel, con plazo de respuesta variable
          según el plan contratado (Básico: hasta 48 horas hábiles por correo electrónico;
          Premium: hasta 4 horas hábiles, por WhatsApp y correo electrónico).</p>

        <h2>10. Limitación de responsabilidad</h2>
        <p>{EMPRESA.nomeFantasia} es una herramienta de apoyo a la gestión de su negocio y
          no sustituye las obligaciones contables, fiscales o legales propias de su empresa.
          No nos responsabilizamos por decisiones tomadas exclusivamente con base en los
          informes del sistema, ni por daños indirectos derivados del uso indebido de la
          plataforma.</p>

        <h2>11. Suspensión y rescisión</h2>
        <p>Podemos suspender o finalizar el acceso en caso de incumplimiento de estos
          términos, falta de pago no resuelta tras aviso, o uso fraudulento/ilícito de la
          plataforma.</p>

        <h2>12. Cambios en estos términos</h2>
        <p>Podemos actualizar estos Términos de Uso para reflejar cambios legales,
          operativos o en los planes ofrecidos. La fecha en la parte superior de esta página
          indica la versión vigente. Los cambios relevantes serán comunicados por los
          canales de contacto registrados.</p>

        <h2>13. Legislación aplicable y jurisdicción</h2>
        <p>Estos términos se rigen por las leyes de la República Federativa de Brasil. Se
          elige el foro de {EMPRESA.cidade}, {EMPRESA.uf}, Brasil para resolver eventuales
          controversias, sin perjuicio del foro del domicilio del consumidor cuando la ley
          así lo determine.</p>

        <h2>14. Contacto</h2>
        <p><a href={`mailto:${EMPRESA.contatoEmail}`}>{EMPRESA.contatoEmail}</a></p>
      </>
    ),
  };

  return (
    <LegalLayout title={TITULOS[lang] || TITULOS.pt} updatedAt={ATUALIZADO[lang] || ATUALIZADO.pt}>
      {CONTEUDO[lang] || CONTEUDO.pt}
    </LegalLayout>
  );
}
